import { isTauri } from '@tauri-apps/api/core';
import { useEffect, useState } from 'react';

/**
 * Returns true when running inside a Tauri environment on a supported mobile platform (Android / iOS).
 * Lightweight synchronous check (no permission probing). Safe for SSR (guards window access).
 */
export function isScannerSupported(): boolean {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return false;
    }
    if (!isTauri()) {
        return false;
    }
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

/**
 * React hook version of scanner support detection. Re-evaluates once on mount.
 * Could be extended later to perform an async capability or permission probe.
 */
export function useScannerSupported(): boolean {
    const [supported, setSupported] = useState<boolean>(() => isScannerSupported());

    useEffect(() => {
        // In case user agent changes (rare) or hydration differences
        setSupported(isScannerSupported());
    }, []);

    return supported;
}
